// Inline upload product section. Pair with main-upload-project.liquid; do not load the popup calculator on this template.
(() => {
'use strict';
const root = document.querySelector('[data-upload-product-section]');
if (!root || root.dataset.initialized === 'true') return;
const config = JSON.parse(root.querySelector('[data-upload-config]').textContent);
const local_app_strings = config.strings;
root.dataset.initialized = 'true';
const uploadProjectApiUrl = 'https://app.wallcolors.com';
const projectNotesLabel = local_app_strings.projectGuidelinesText || 'Wytyczne / ustalenia dotyczące projektu';
const uploadProjectRequiredText = local_app_strings.uploadProjectRequiredText || 'Najpierw prześlij obraz swojego projektu.';
let savedState = null;

function openEmailPopup(e) {
    e.preventDefault();
    root.querySelector('#ngsp-email-popup').classList.add('ngsp-email-active');
    root.querySelector('#ngsp-email-subject').focus();
}
function closeEmailPopup(e) {
    e.preventDefault();
    root.querySelector('#ngsp-email-popup').classList.remove('ngsp-email-active');
    root.querySelector('#btnSaveConfiguration')?.focus();
}
root.querySelector('#ngsp-email-popup')?.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeEmailPopup(event);
    if (event.key !== 'Tab') return;
    const controls = Array.from(event.currentTarget.querySelectorAll('button, input')).filter(item => !item.disabled);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
});
function getStorefrontPriceFormatter() {
    const priceElement = root.querySelector('[data-unit-price]');
    let priceText = '';

    if (priceElement) {
        const priceNode = Array.from(priceElement.childNodes)
            .reverse()
            .find(node => /\d/.test((node.textContent || '').trim()));
        priceText = (priceNode?.textContent || '').trim();
    }

    if (!priceText) priceText = config.formattedVariantPrice || '';
    priceText = priceText.replace(/\/\s*\S+$/, '').trim();

    const formatSample = (config.moneyFormatSample || priceText).trim();
    const sampleFirstDigit = formatSample.search(/\d/);
    let sampleLastDigit = -1;
    for (let index = formatSample.length - 1; index >= 0; index--) {
        if (/\d/.test(formatSample[index])) {
            sampleLastDigit = index;
            break;
        }
    }
    const sampleNumber = sampleFirstDigit >= 0 && sampleLastDigit >= sampleFirstDigit
        ? formatSample.slice(sampleFirstDigit, sampleLastDigit + 1)
        : '';
    const decimalMatch = sampleNumber.match(/([^\d])(\d{2})$/);
    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
    const integerSample = decimalMatch
        ? sampleNumber.slice(0, decimalMatch.index)
        : sampleNumber;
    const groupingMatch = integerSample.match(/[^\d]/);
    const groupingSeparator = groupingMatch ? groupingMatch[0] : '';

    const firstDigit = priceText.search(/\d/);
    let lastDigit = -1;
    for (let index = priceText.length - 1; index >= 0; index--) {
        if (/\d/.test(priceText[index])) {
            lastDigit = index;
            break;
        }
    }

    // Match the same symbol token used by the main calculator, while deriving
    // its prefix/suffix position from the storefront's rendered price.
    const currencyMatch = priceText.match(/([^\d\s.,]+)/);
    const symbol = currencyMatch ? currencyMatch[0] : '';
    const symbolAtEnd = !!currencyMatch && currencyMatch.index > lastDigit;

    return value => {
        const numericValue = Number.isFinite(Number(value)) ? Number(value) : 0;
        const fixedParts = numericValue.toFixed(2).split('.');
        const integerPart = groupingSeparator
            ? fixedParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupingSeparator)
            : fixedParts[0];
        const amount = `${integerPart}${decimalSeparator}${fixedParts[1]}`;
        if (!symbol) return amount;
        return symbolAtEnd ? `${amount} ${symbol}` : `${symbol} ${amount}`;
    };
}
function getProductForm() {
    return root.querySelector('form.shopify-product-form');
}
function setHiddenProperty(form, propertyName, value) {
    const inputName = `properties[${propertyName}]`;
    let input = Array.from(form.querySelectorAll('input[type="hidden"]'))
        .find(item => item.name === inputName);
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        form.appendChild(input);
    }
    input.value = value;
}
function showButtonSpinner(button) {
    if (!button.querySelector('.ngsp-spinner')) {
        const spinner = document.createElement('div');
        spinner.className = 'ngsp-spinner';
        button.appendChild(spinner);
    }
    const text = button.querySelector('.ngsp-button-text');
    if (text) text.style.visibility = 'hidden';
    button.classList.add('ngsp-button-loading');
}
function hideButtonSpinner(button) {
    button.querySelector('.ngsp-spinner')?.remove();
    const text = button.querySelector('.ngsp-button-text');
    if (text) text.style.visibility = 'visible';
    button.classList.remove('ngsp-button-loading');
}
function preserveConfigurationOnLocalizationChange(event) {
    const currentUrl = new URL(window.location.href);
    const configurationId = currentUrl.searchParams.get('configurationId');
    if (!configurationId) return;

    const localizationButton = event.target.closest(
        'button[name="country_code"], button[name="language_code"]'
    );
    if (!localizationButton) return;

    const localizationForm = localizationButton.closest('form');
    const returnInput = localizationForm?.querySelector('input[name="return_to"]');
    if (!returnInput) return;

    const returnUrl = new URL(returnInput.value || currentUrl.href, window.location.origin);
    returnUrl.searchParams.set('configurationId', configurationId);

    if (localizationButton.name === 'country_code') {
        if (window.ngsInlineProjectAutoCurrencyChange) {
            window.ngsInlineProjectAutoCurrencyChange = false;
            returnUrl.searchParams.delete('isMCR');
        } else {
            returnUrl.searchParams.set('isMCR', '1');
        }
    } else if (currentUrl.searchParams.has('isMCR')) {
        returnUrl.searchParams.set('isMCR', currentUrl.searchParams.get('isMCR'));
    }

    returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
}
document.addEventListener('click', preserveConfigurationOnLocalizationChange);
async function ensureArtworkSaved(state, statusElement) {
    if (!state.artworkDirty && state.artworkUrl) return state.artworkUrl;
    if (!state.file) throw new Error(uploadProjectRequiredText);
    if (state.artworkUploadPromise) {
        const pendingUrl = await state.artworkUploadPromise;
        if (!pendingUrl && state.artworkDirty) return ensureArtworkSaved(state, statusElement);
        return pendingUrl;
    }

    statusElement.textContent = local_app_strings.uploadingText || 'Uploading image…';
    const fileBeingUploaded = state.file;
    const revisionBeingUploaded = state.artworkRevision;
    const formData = new FormData();
    formData.append('image', fileBeingUploaded);
    formData.append('product_id', String(config.product.id));

    state.artworkUploadPromise = fetch(`${uploadProjectApiUrl}/upload_project_image.php`, {
        method: 'POST',
        body: formData
    }).then(async response => {
        const result = await response.json().catch(() => null);
        if (!response.ok || !result?.status || !result.image_url) {
            throw new Error(result?.message || local_app_strings.uploadErrorText);
        }
        if (state.artworkRevision !== revisionBeingUploaded || state.file !== fileBeingUploaded) {
            return '';
        }
        state.artworkUrl = result.image_url;
        state.artworkFileName = result.original_name || fileBeingUploaded.name;
        state.artworkDirty = false;
        statusElement.textContent = state.artworkFileName;
        return state.artworkUrl;
    }).catch(error => {
        state.artworkDirty = true;
        throw error;
    }).finally(() => {
        state.artworkUploadPromise = null;
    });

    const uploadedUrl = await state.artworkUploadPromise;
    if (!uploadedUrl && state.artworkDirty) return ensureArtworkSaved(state, statusElement);
    return uploadedUrl;
}
function getUploadProjectConfiguration(state) {
    const productUrl = new URL(window.location.href);
    productUrl.searchParams.delete('configurationId');
    productUrl.searchParams.delete('uploadProject');
    productUrl.searchParams.delete('isMCR');
    return {
        popupMode: 'uploadProject',
        productId: String(config.product.id),
        variantId: String(state.variantId || config.selectedVariantId),
        measurementType: state.unit,
        width: state.width,
        height: state.height,
        specialNotes: state.notes,
        artworkUrl: state.artworkUrl,
        artworkFileName: state.artworkFileName,
        productName: config.product.title,
        product_url: productUrl.toString(),
        country: window.Shopify?.country || ''
    };
}
async function addUploadProjectToCart(state, unitPrice, formatPrice, statusElement) {
    const form = getProductForm();
    if (!form) throw new Error('Unable to find the product form.');

    const artworkUrl = await ensureArtworkSaved(state, statusElement);

    const unitFactor = state.unit === 'inch' ? 0.0254 : 0.01;
    const totalPrice = Number(state.width) * Number(state.height) * unitFactor * unitFactor * unitPrice;
    const currencyRate = Number(window.Shopify?.currency?.rate) || 1;
    const customBasePrice = (totalPrice / currencyRate).toFixed(2);
    const unitBasePrice = (unitPrice / currencyRate).toFixed(2);
    const activeCurrency = window.Shopify?.currency?.active || '';
    const sizeValue = `${local_app_strings.cartWidthText || 'Width'} ${state.width} ${state.unit} × ${local_app_strings.cartHeightText || 'Height'} ${state.height} ${state.unit}`;
    const readableProperties = {
        [local_app_strings.sizeText || 'Size']: sizeValue,
        [local_app_strings.priceText || 'Price']: formatPrice(totalPrice),
        'Selected Image': artworkUrl
    };
    if (state.notes.trim()) {
        readableProperties[projectNotesLabel] = state.notes.trim();
    }

    Object.entries(readableProperties).forEach(([name, value]) => setHiddenProperty(form, name, value));
    setHiddenProperty(form, '__ngs_customPrice', customBasePrice);
    setHiddenProperty(form, '__ngs_customPriceProductText', 'product title');
    setHiddenProperty(form, '__ngs_productBaseCurrencyPrice', unitBasePrice);
    setHiddenProperty(form, '__ngs_originalCurrency', activeCurrency);
    setHiddenProperty(form, '__ngs_all_properties_data', JSON.stringify(readableProperties));

    const artworkInput = root.querySelector('#ngsp-project-artwork');
    artworkInput.removeAttribute('name');
    artworkInput.removeAttribute('form');

    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) quantityInput.value = '1';
    const nativeButton = form.querySelector('buy-buttons button[type="submit"], button[name="add"]');
    if (!nativeButton) throw new Error('Unable to find the original Add to Cart button.');
    nativeButton.click();
}
// Uploaded artwork has no relationship to the calculator's repeat/crop state.
function bindProjectForm (popup, settings, product, calculator) {
    const state = savedState || (savedState = {
    file: null,
    previewUrl: '',
    width: settings.defaultWidthValue || 200,
    height: settings.defaultHeightValue || 200,
    unit: 'cm',
    notes: '',
    variantId: String(config.selectedVariantId),
    artworkUrl: '',
    artworkFileName: '',
    artworkDirty: false,
    artworkRevision: 0,
    artworkUploadPromise: null
});
    const fields = popup.querySelector('[data-project-fields]');
    fields.disabled = false;
    popup.querySelector('#ngsp-width-input').value = state.width;
    popup.querySelector('#ngsp-height-input').value = state.height;
    popup.querySelector('#ngsp-spl-instructions').value = state.notes;
    popup.querySelector('#ngsp-measure_type').value = state.unit;
    const unitToggle = popup.querySelector('.ngsp-measure-unit-toggle');
    unitToggle.dataset.currentValue = state.unit;
    unitToggle.dataset.index = state.unit === 'inch' ? '1' : '0';
    unitToggle.setAttribute('aria-pressed', String(state.unit === 'inch'));
    popup.querySelector('#ngsp-measure-price').textContent = '(' + calculator.formatPrice(calculator.unitPrice) + '/m²)';
    const find = selector => popup.querySelector(selector);
    const variantSelect = find('#ngsp-variant-select');
    const variantInput = find('#ngsp-product-variant-id');

    if (variantSelect && state.variantId) {
        variantSelect.value = String(state.variantId);

        if (variantInput) {
            variantInput.value = String(state.variantId);
        }

        calculator.setVariant(state.variantId);
    }
    const preview = find('#ngsp-project-preview');
    const validationError = find('#ngsp-project-validation-error');
    function showValidationError(message = '') {
        validationError.textContent = message;
        validationError.hidden = !message;
    }
    // Element-only sizing; existing class definitions and properties stay untouched.
    preview.style.cssText = 'width:100%;height:400px;object-fit:contain;';
    function showPreview() {
        preview.hidden = !state.previewUrl;
        if (state.previewUrl) preview.src = state.previewUrl;
        find('#ngsp-project-upload-label').hidden = !!state.previewUrl;
        find('.ngsp-top-image-repeat').classList.toggle('ngsp-project-upload-empty', !state.previewUrl);
        find('#ngsp-project-replace').hidden = !state.previewUrl || !config.eligible;
    }
    function updatePrice() {
        state.width = find('#ngsp-width-input').value;
        state.height = find('#ngsp-height-input').value;
        if ([state.width, state.height].every(value => Number.isFinite(Number(value)) && Number(value) > 0)) {
            calculator.price();
        } else {
            find('#ngsp-final-price').textContent = '—';
        }
    }
    find('#ngsp-width-input').addEventListener('input', updatePrice);
    find('#ngsp-height-input').addEventListener('input', updatePrice);
    find('#ngsp-spl-instructions').addEventListener('input', event => { state.notes = event.target.value; });

   

    // Variant dropdown
  find('#ngsp-variant-select')?.addEventListener('change', function () {
    state.variantId = String(this.value);

    const variantInput = find('#ngsp-product-variant-id');

    if (variantInput) {
        variantInput.value = state.variantId;
    }

    calculator.setVariant(state.variantId);

    find('#ngsp-measure-price').textContent =
        '(' + calculator.formatPrice(calculator.unitPrice) + '/m²)';

    updatePrice();
});

    function changeMeasurementUnit(newUnit) {
        if (newUnit === state.unit) return;
        const factor = newUnit === 'inch' ? 1 / 2.54 : 2.54;
        state.unit = newUnit;
        for (const dimension of ['width', 'height']) {
            const input = find(`#ngsp-${dimension}-input`);
            if (input.value !== '') input.value = (Number(input.value) * factor).toFixed(2);
        }
        const toggle = find('.ngsp-measure-unit-toggle');
        toggle.dataset.currentValue = state.unit;
        toggle.dataset.index = state.unit === 'inch' ? '1' : '0';
        toggle.setAttribute('aria-pressed', state.unit === 'inch' ? 'true' : 'false');
        find('#ngsp-measure_type').value = state.unit;
        updatePrice();
    }
    find('.ngsp-measure-unit-toggle').addEventListener('click', () => {
        changeMeasurementUnit(state.unit === 'cm' ? 'inch' : 'cm');
    });
    popup.querySelectorAll('.ngsp-msr[data-unit]').forEach(label => {
        label.addEventListener('click', () => changeMeasurementUnit(label.dataset.unit));
        label.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                changeMeasurementUnit(label.dataset.unit);
            }
        });
    });
    find('#ngsp-project-replace').addEventListener('click', () => find('#ngsp-project-artwork').click());
    let imageSelectionRevision = 0;
    function selectArtwork(file) {
        if (!file) return;
        if (!config.eligible && state.artworkUrl) return;
        const selectionRevision = ++imageSelectionRevision;
        const status = find('#ngsp-project-upload-status');
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
            status.textContent = local_app_strings.invalidImageText;
            find('#ngsp-project-artwork').value = '';
            return;
        }
        const url = URL.createObjectURL(file);
        const candidate = new Image();
        candidate.onload = () => {
            if (selectionRevision !== imageSelectionRevision) {
                URL.revokeObjectURL(url);
                return;
            }
            if (state.previewUrl.startsWith('blob:')) URL.revokeObjectURL(state.previewUrl);
            state.file = file;
            state.previewUrl = url;
            state.artworkUrl = '';
            state.artworkFileName = file.name;
            state.artworkDirty = true;
            state.artworkRevision += 1;
            status.textContent = file.name;
            showValidationError();
            showPreview();
        };
        candidate.onerror = () => {
            URL.revokeObjectURL(url);
            if (selectionRevision !== imageSelectionRevision) return;
            status.textContent = local_app_strings.imageOpenErrorText;
        };
        candidate.src = url;
    }
    find('#ngsp-project-artwork').addEventListener('change', event => {
        selectArtwork(event.target.files[0]);
    });
    const dropArea = find('.ngsp-top-image-repeat');
    const uploadLabel = find('#ngsp-project-upload-label');
    uploadLabel.tabIndex = 0;
    uploadLabel.setAttribute('role', 'button');
    uploadLabel.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            find('#ngsp-project-artwork').click();
        }
    });
    dropArea.addEventListener('dragover', event => {
        event.preventDefault();
        const canUpload = config.eligible || !state.artworkUrl;
        if (event.dataTransfer) event.dataTransfer.dropEffect = canUpload ? 'copy' : 'none';
        dropArea.classList.toggle('ngsp-project-drag-over', canUpload);
    });
    dropArea.addEventListener('dragleave', event => {
        if (!dropArea.contains(event.relatedTarget)) dropArea.classList.remove('ngsp-project-drag-over');
    });
    dropArea.addEventListener('drop', event => {
        event.preventDefault();
        dropArea.classList.remove('ngsp-project-drag-over');
        selectArtwork(event.dataTransfer?.files[0]);
    });
    find('#ngsp-add-to-cart').addEventListener('click', async event => {
        event.preventDefault();
        const button = event.currentTarget;
        if (!find('#ngsp-width-input').reportValidity() || !find('#ngsp-height-input').reportValidity()) return;
        if (!state.file && !state.artworkUrl) {
            showValidationError(uploadProjectRequiredText);
            return;
        }
        showValidationError();
        button.disabled = true;
        showButtonSpinner(button);
        const resetButton = () => {
            button.disabled = false;
            hideButtonSpinner(button);
        };
        try {
            await calculator.addToCart(state, find('#ngsp-project-upload-status'));
            setTimeout(resetButton, 1600);
        } catch (error) {
            console.error('Upload project add to cart:', error);
            showValidationError(error.message || local_app_strings.cartErrorText);
            resetButton();
        }
    });
    find('#btnSaveConfiguration')?.addEventListener('click', event => {
        event.preventDefault();
        if (!find('#ngsp-width-input').reportValidity() || !find('#ngsp-height-input').reportValidity()) return;
        if (!state.file && !state.artworkUrl) {
            showValidationError(uploadProjectRequiredText);
            return;
        }
        showValidationError();
        openEmailPopup(event);
    });
    find('#ngsp-email-popup-close')?.addEventListener('click', closeEmailPopup);
    find('#frmMailPopup')?.addEventListener('submit', async event => {
        event.preventDefault();
        const submitButton = find('#ngsp-email-popup-save-btn');
        if (submitButton.disabled) return;
        submitButton.disabled = true;
        submitButton.style.pointerEvents = 'none';
        try {
            await ensureArtworkSaved(state, find('#ngsp-project-upload-status'));
            const formData = new URLSearchParams();
            formData.append('email', config.customer.email);
            formData.append('emailSubject', find('#ngsp-email-subject').value);
            formData.append('ccemail', find('#ngsp-cc-email').value);
            formData.append('lang', document.documentElement.lang || 'pl');
            formData.append('config', JSON.stringify(getUploadProjectConfiguration(state)));
            const response = await fetch(`${uploadProjectApiUrl}/save_configuration.php`, {
                method: 'POST',
                body: formData
            });
            const result = await response.json().catch(() => null);
            if (!response.ok || !result?.status) throw new Error(result?.message || local_app_strings.saveErrorText);
            alert(local_app_strings.emailSent || 'The project has been saved and sent.');
            closeEmailPopup(event);
        } catch (error) {
            console.error('Upload project save:', error);
            showValidationError(error.message || local_app_strings.saveErrorText);
        } finally {
            submitButton.disabled = false;
            submitButton.style.pointerEvents = 'auto';
        }
    });
    showPreview();
    find('#ngsp-project-upload-status').textContent = state.artworkFileName;
    updatePrice();
}

async function loadSavedUploadProject() {
 const configurationId = new URLSearchParams(location.search).get('configurationId');
 if (!configurationId) return false;
 try {
  const formData = new URLSearchParams();
  formData.append('configuration_id', configurationId);
  const response = await fetch(`${uploadProjectApiUrl}/get_configuration.php`, { method:'POST', body:formData });
  const result = await response.json();
  const data = result?.status ? result.config : null;
  if (!data || data.popupMode !== 'uploadProject' || String(data.productId) !== String(config.product.id) || !data.artworkUrl) return false;
  savedState = {
   file:null, previewUrl:data.artworkUrl, artworkUrl:data.artworkUrl,
   artworkFileName:data.artworkFileName || '', artworkDirty:false,
   artworkRevision:0, artworkUploadPromise:null,
   width:data.width || 200, height:data.height || 200,
   unit:data.measurementType === 'inch' ? 'inch' : 'cm', notes:data.specialNotes || '',
   variantId: String(data.variantId || config.selectedVariantId),
  };
  return data;
 } catch(error) {
  console.error('Upload project restore:',error);
  return false;
 }
}
async function init() {
 const status = root.querySelector('[data-page-status]');
 const restoredConfiguration = await loadSavedUploadProject();
 const shouldRestore = !!restoredConfiguration;
 if (!config.eligible && !shouldRestore) {
  status.textContent = local_app_strings.accessText;
  root.querySelector('[data-project-fields]').hidden = true;
  return;
 }
 if (shouldRestore && !new URLSearchParams(location.search).has('isMCR')) {
  const savedCountry = String(restoredConfiguration.country || 'PL').toUpperCase();
  const currentCountry = String(window.Shopify?.country || '').toUpperCase();
  if (currentCountry && savedCountry !== currentCountry) {
   const savedCountryButton = Array.from(document.querySelectorAll('button[name="country_code"]'))
    .find(item => String(item.value).toUpperCase() === savedCountry);
   if (savedCountryButton) {
    window.ngsInlineProjectAutoCurrencyChange = true;
    savedCountryButton.click();
    return;
   }
  }
 }


 try {
    const initialVariantId = savedState?.variantId || config.selectedVariantId;

    const variant = config.product.variants.find(
        v => String(v.id) === String(initialVariantId)
    ) || config.product.variants[0];

    if (!variant?.available) {
        throw new Error(local_app_strings.unavailableText);
    }

    let unitPrice = Number(variant.price) / 100;

    if (!Number.isFinite(unitPrice) || unitPrice <= 0) {
        throw new Error(local_app_strings.unavailableText);
    }

    const formatPrice = getStorefrontPriceFormatter();

    const calculator = {
        get unitPrice() {
            return unitPrice;
        },

        formatPrice,

        setVariant(variantId) {
            const selectedVariant = config.product.variants.find(
                v => String(v.id) === String(variantId)
            );

            if (!selectedVariant) return false;

            unitPrice = Number(selectedVariant.price) / 100;
            return true;
        },

        price() {
            const factor = savedState.unit === 'inch' ? 0.0254 : 0.01;

            root.querySelector('#ngsp-final-price').textContent =
                formatPrice(
                    Number(savedState.width) *
                    Number(savedState.height) *
                    factor *
                    factor *
                    unitPrice
                );
        },

        addToCart(state, statusElement) {
            return addUploadProjectToCart(
                state,
                unitPrice,
                formatPrice,
                statusElement
            );
        }
    };

    bindProjectForm(
        root,
        local_app_strings,
        config.product,
        calculator
    );

    status.textContent = '';

} catch(error) {
    console.error('Upload project init:', error);
    status.textContent =
        error.message || local_app_strings.loadErrorText;
}
}
init();
})();
